import { formatPhoneNumberIntl } from "react-phone-number-input";
import PrimaryButton from "../components/PrimaryButton";
import { CardSubtitle, CardTitle, IconBadge, Notice } from "../components/AuthCard";
import { HeadsetIcon, ShieldIcon } from "../components/Icons";
import { CS_PHONE } from "../constants";

const NEXT_STEPS = [
  <>
    You&apos;ll get a call from{" "}
    <span className="font-geomanistBold text-blackShade">{CS_PHONE}</span> within 24
    working hours.
  </>,
  "We'll ask a few questions to confirm it's you.",
  "Once your number is updated, log in again and verify with OTP.",
];

// A9
const RequestReceived = ({ mobile, referenceId, onBack }) => (
  <div className="flex flex-col items-center text-center">
    <IconBadge className="mb-4">
      <HeadsetIcon />
    </IconBadge>
    <CardTitle>Request received</CardTitle>
    <CardSubtitle>
      We&apos;ll call you on{" "}
      <span className="font-geomanistBold text-blackShade">
        {formatPhoneNumberIntl(mobile) || mobile}
      </span>{" "}
      to verify your identity.
    </CardSubtitle>

    <div className="w-full mt-5 rounded-lg bg-[#F7F7F8] py-2.5 font-geomanistRegular text-xs text-geomanistgray">
      Reference ID{" "}
      <span className="font-geomanistBold text-blackShade">{referenceId}</span>
    </div>

    <div className="w-full mt-3 rounded-xl border border-[#E3E4E8] p-4 text-left">
      <p className="mb-3 font-geomanistMedium text-sm text-blackShade">
        What happens next
      </p>
      <ol className="list-none p-0 m-0 flex flex-col gap-2.5">
        {NEXT_STEPS.map((step, index) => (
          <li
            key={index}
            className="flex items-start gap-2.5 font-geomanistRegular text-xs leading-5 text-geomanistgray"
          >
            <span className="w-5 h-5 shrink-0 rounded-full bg-[#E6EFFB] text-blueish flex items-center justify-center text-[11px] font-geomanistMedium">
              {index + 1}
            </span>
            <span>{step}</span>
          </li>
        ))}
      </ol>
    </div>

    <Notice tone="amber" icon={<ShieldIcon className="w-3.5 h-3.5" />} className="w-full mt-3 text-left">
      Borderless will never ask for your password or OTP on a call.
    </Notice>

    <div className="w-full mt-5">
      <PrimaryButton title="Back to login" onClick={onBack} />
    </div>
  </div>
);

export default RequestReceived;
